/**
 * Encrypted read-through cache for GET responses.
 * api.js writes every successful GET here and serves from it when offline,
 * so Dashboard / Reports / Search / Settings behave the same without internet.
 */
import { secureGet, secureSet } from "@/lib/secureStore";

const PREFIX = "am_cache::";

export async function cachePut(urlKey, data) {
  try {
    await secureSet(PREFIX + urlKey, { data, at: new Date().toISOString() });
  } catch (e) { console.debug("cachePut failed", e); }
}

export async function cacheGet(urlKey) {
  const rec = await secureGet(PREFIX + urlKey);
  return rec ? rec.data : undefined;
}
